import { ref } from 'vue';
import Userback from '@userback/widget';

const userbackInstance = ref(null);

export function useUserback() {
  const initUserback = async (token, settings = {}) => {
    if (!userbackInstance.value) {
      userbackInstance.value = await Userback(token, settings);
    }
    return userbackInstance.value;
  };

  return {
    userback: userbackInstance,
    initUserback,
  };
}
